export const CURRENCIES = {
  POKE_DOLLAR: 1,
  COIN: 2,
  VOLCANIC_ASH: 3,
  POKE_COUPON: 4,
  BERRY_POWDER: 5,
  BATTLE_POINT: 6,
  SPHERE: 7,
  CASTLE_POINT: 8,
  WATT: 9,
  ATHLETE_POINT: 10,
  DREAM_POINT: 11,
  DREAM_WORLD_BERRY: 12,
  POKE_MILE: 13,
  FESTIVAL_COIN: 14,
  POKE_BEAN: 15,
  HOME_POINT: 16,
  MERIT_POINT: 17,
  LEAGUE_POINT: 18,
  BLUEBERRY_POINT: 19,
} as const;
